import React from 'react';

import Radio from 'antd/lib/radio';

import Admin from 'hive-admin/src/components/Admin';
import Field from 'hive-admin/src/components/Field';
import FieldSelect from 'hive-admin/src/components/FieldSelect';

import './FieldRadioVertical.less';

export default class FieldRadioVertical extends FieldSelect {
  static config = {
    ...FieldSelect.config,
    Component: Radio.Group,
    choiceClass: Radio.Button,
    choiceClassTablet: Radio,
    getChoiceClass: props => (
      props.isTablet
      ? props.choiceClassTablet
      : props.choiceClass
    ),
    // eslint-disable-next-line no-unused-vars
    prepareValueForInput: (value, props) => value,
    // eslint-disable-next-line no-unused-vars
    prepareValueForForm: (value, props) => value,
    renderChoice: (choice, field, props) => {
      const Element = props.getChoiceClass(props);
      return (
        <Element
          key={props.getChoiceValue(choice, field, props)}
          value={props.getChoiceValue(choice, field, props)}
        >
          {props.getChoiceLabel(choice, field, props)}
        </Element>
      );
    },
  }

  static inputPropsMap = {
    ...Field.inputPropsMap,
    buttonStyle: true,
    defaultChecked: true,
  }

  handleChange = (event) => {
    this.props.onChange({
      ...event,
      target: {
        ...event.target,
        value: this.props.prepareValueForForm(event.target.value, this.props),
      },
    });
  }

  renderInput(props) {
    return (
      <this.props.Component
        key={props.name}
        {...props}
        value={props.value}
        onChange={this.handleChange}
      >
        {this.props.renderChoices(this, this.getStatefullProps())}
      </this.props.Component>
    );
  }
}

Admin.addToLibrary(
  'FieldRadioVertical',
  config => FieldRadioVertical.create(config),
);
